import { Button as UIButton } from "../ui/button";

type Props = React.ComponentProps<typeof UIButton>;

export function Button({ children, ...props }: Props) {
	return <UIButton {...props}>{children}</UIButton>;
}
